export interface DeepLinkParams {
  partner?: string;
  campaign?: string;
}

export function parseDeepLink(url: string): DeepLinkParams | null {
  try {
    if (url.startsWith('medikei://')) {
      const pathAndQuery = url.replace('medikei://', '');
      const [, query] = pathAndQuery.split('?');

      const params = new URLSearchParams(query);
      return {
        partner: params.get('partner') || undefined,
        campaign: params.get('campaign') || undefined,
      };
    }

    // Handle /p/{hash} URL pattern (e.g., medikei.com/p/ALMIR123)
    const pMatch = url.match(/\/p\/([A-Za-z0-9]+)/);
    if (pMatch) {
      return {
        partner: pMatch[1],
        campaign: undefined,
      };
    }

    if (url.includes('partner=')) {
      const urlObj = new URL(url);
      return {
        partner: urlObj.searchParams.get('partner') || undefined,
        campaign: urlObj.searchParams.get('campaign') || undefined,
      };
    }

    // Also handle campaignCode parameter (e.g., ?campaignCode=ALMIR123)
    if (url.includes('campaignCode=')) {
      const urlObj = new URL(url);
      return {
        partner: urlObj.searchParams.get('campaignCode') || undefined,
        campaign: urlObj.searchParams.get('campaignCode') || undefined,
      };
    }

    return null;
  } catch {
    return null;
  }
}

export function buildDeepLink(service: 'telemedicina' | 'domiciliar', partnerHash: string): string {
  return `medikei://${service}?partner=${partnerHash}`;
}

export function buildWebLink(service: 'telemedicina' | 'domiciliar', partnerHash: string): string {
  const baseUrl = typeof window !== 'undefined' && window.location.origin
    ? (window.location.origin.includes('localhost') ? window.location.origin : 'https://www.medikei.com.br')
    : 'https://www.medikei.com.br';
  return `${baseUrl}/${service}?partner=${partnerHash}`;
}

const PARTNER_STORAGE_KEY = 'medikei_partner_hash';

export function storePartnerHash(hash: string): void {
  if (typeof window !== 'undefined') {
    localStorage.setItem(PARTNER_STORAGE_KEY, hash);
    sessionStorage.setItem(PARTNER_STORAGE_KEY, hash);
  }
}

export function getStoredPartnerHash(): string | null {
  if (typeof window === 'undefined') return null;
  return sessionStorage.getItem(PARTNER_STORAGE_KEY) || localStorage.getItem(PARTNER_STORAGE_KEY);
}

export function clearPartnerHash(): void {
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem(PARTNER_STORAGE_KEY);
  }
}
